export default function GroupsIntroComponent() {
  return (
    <div className=" items-center justify-center flex h-screen w-screen absolute top-0 left-0">
      <img className="w-screen" src="/groups-intro.svg" alt="" />
    </div>
  );
}
